<template>
  <v-container id="taxslabs" fluid tag="section">
    <div class="text-right">
      <v-btn color="cyan" @click="showFilter = !showFilter" small>
        <v-icon>mdi-filter</v-icon>
      </v-btn>
    </div>

    <v-row justify="center" v-if="showFilter">
      <v-col cols="12" md="12">
        <base-material-card
          color="cyan"
          icon="mdi-filter"
          class="px-3 py-1 small-icon"
          v-if="showFilter"
        >
          <div class="filter-close">
            <v-btn color="black" class="mr-0" fab small text @click="showFilter = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <v-row>
            <v-col cols="12" md="2">
              <z-client-select class="purple-input" v-model="filters.client_id" withSelf />
            </v-col>
            <v-col cols="12" md="2">
              <z-entity-select
                :label="$i18n.t('Client Entity')"
                class="purple-input"
                v-model="filters.clientEntity_id"
                :corp="filters.client_id"
              />
            </v-col>
            <v-col cols="12" md="2">
              <z-vendor-select class="purple-input" v-model="filters.vendor_id" withSelf />
            </v-col>
            <v-col cols="12" md="2">
              <z-entity-select
                :label="$i18n.t('Vendor Entity')"
                class="purple-input"
                v-model="filters.vendorEntity_id"
                :corp="filters.vendor_id"
              />
            </v-col>
            <v-col cols="12" md="2">
              <z-vendor-select
                :label="$i18n.t('Supplier')"
                class="purple-input"
                v-model="filters.supplier_id"
              />
            </v-col>
            <v-col cols="12" md="2">
              <z-country-select class="purple-input" v-model="filters.sourceCountry" />
            </v-col>
            <v-col cols="12" md="2">
              <z-city-select
                :label="$i18n.t('Source City')"
                class="purple-input"
                v-model="filters.sourceCity"
                :country="filters.sourceCountry"
              />
            </v-col>
            <v-col cols="12" md="2">
              <z-city-select
                :label="$i18n.t('Destination City')"
                class="purple-input"
                v-model="filters.destinationCity"
                :country="filters.sourceCountry"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                :label="$i18n.t('Tariff Name')"
                class="purple-input"
                v-model="filters.name"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                :label="$i18n.t('Tariff No')"
                class="purple-input"
                v-model="filters.tariffNo"
              />
            </v-col>
            <v-col cols="12" md="2">
              <z-vehicle-type-select class="purple-input" v-model="filters.vehicleType" />
            </v-col>

            <v-col cols="12" md="2" class="text-right">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="mr-0"
                    color="grey darken"
                    fab
                    text
                    small
                    @click="clear(1)"
                    style="margin-right:10px !important"
                    v-on="on"
                  >
                    <v-icon>mdi-cached</v-icon>
                  </v-btn>
                </template>
                <span>{{ $i18n.t("Clear Filter") }}</span>
              </v-tooltip>
              <v-btn
                color="success"
                class="mr-0"
                fab
                small
                dark
                @click="search()"
                :loading="loading"
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </base-material-card>
      </v-col>
    </v-row>

    <v-btn
      v-if="grid != undefined && !grid.records"
      class="text-center secondary--text pa-10"
      text
      color="primary"
      style="width:100%"
      :loading="loading"
    >{{ $i18n.t("No records available") }}</v-btn>

    <base-material-card
      icon="mdi-domain"
      :title="$i18n.t('Rate Cards')"
      class="px-5 py-3"
      v-if="grid.records"
    >
      <z-grid-record :grid="grid" />
      <v-simple-table>
        <thead>
          <tr>
            <th class="primary--text"></th>
            <th class="primary--text">{{ $i18n.t("City") }}</th>
            <th class="primary--text">{{ $i18n.t("Client") }}</th>
            <th class="primary--text">{{ $i18n.t("Vendor") }}</th>
            <th class="primary--text">{{ $i18n.t("Supplier") }}</th>
            <th class="primary--text">{{ $i18n.t("Fare") }}</th>
            <th class="primary--text">{{ $i18n.t("Tariff") }}</th>
            <th class="primary--text">{{ $i18n.t("Validity") }}</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="vehicleSearch in grid.rows" :key="vehicleSearch._id">
            <td>
              <v-img ng-show="vehicleSearch.pic" :src="vehicleSearch.pic" width="50" />
              <v-icon ng-show="!vehicleSearch.pic" width="50">mdi-vehicle</v-icon>
              <br />
              {{vehicleSearch.bodyType}}
              <br />
              {{vehicleSearch.vehicleType}}
              <br />
            </td>
            <td>
              <span
                v-for="(city, index) in vehicleSearch.cities"
                :key="city"
                v-show="index < 2 || vehicleSearch.showAll"
              >{{index != 0 ? ", &nbsp;" + city : city}}</span>
              <v-btn
                small
                text
                v-show="vehicleSearch.cities.length > 2 && !vehicleSearch.showAll"
                @click="vehicleSearch.showAll = true"
              >&nbsp; +{{vehicleSearch.cities.length - 2}} more...</v-btn>
            </td>
            <td>{{vehicleSearch.clientName}}</td>
            <td>{{vehicleSearch.vendorName}}</td>
            <td>{{vehicleSearch.supplier}}</td>
            <td>{{vehicleSearch.currency}}&nbsp;{{vehicleSearch.price}}</td>

            <td>
              <a :href="'/w/rates/' + vehicleSearch.tariff_id">{{vehicleSearch.name }}</a>
              <br />
              {{vehicleSearch.tariffType}}
            </td>
            <td>
              {{vehicleSearch.validFrom | moment("DD MMM YYYY")}} -
              {{vehicleSearch.validTill | moment("DD MMM YYYY")}}
            </td>
          </tr>
        </tbody>
      </v-simple-table>
      <v-container>
        <v-row justify="center">
          <v-col cols="8">
            <v-container class="max-width">
              <v-pagination
                v-model="grid.page"
                class="my-4"
                :length="grid.total"
                total-visible="10"
                @input="showPage"
              ></v-pagination>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </base-material-card>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class TaxSlabs extends Vue {
  grid = { page: 0 };
  rows = 20;
  url = "/api/vehicleSearch/data/grid?rows=" + this.rows;
  showFilter = false;
  name = "";
  menu1 = false;
  filterUrl = "";
  country = "";
  city = "";
  on = null;
  page = 1;
  filters = {
    sourceCity: null,
    sourceCountry: null,
    client_id: null,
    clientEntity_id: null,
    vendor_id: null,
    vendorEntity_id: null,
    supplier_id: null,
    destinationCity: null,
    name: null,
    tariffNo: null,
    vehicleType: null,
  };

  get loading() {
    return common.loading;
  }

  async mounted() {
    common.setLoading(true);
    try {
      const response = await doGet(this.url);
      for (let i = 0; i < response.rows.length; i++) {
        response.rows[i].showAll = false;
      }
      this.grid = response;
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  async showPage(page) {
    this.page = page;
    const response = await doGet(this.url + this.filterUrl + "&page=" + page);
    for (let i = 0; i < response.rows.length; i++) {
      response.rows[i].showAll = false;
    }
    this.grid = response;
    common.setLoading(false);
  }

  async clear() {
    this.filters = {};
    this.page = 1;
    this.search();
  }

  async search() {
    this.filterUrl = "";
    if (this.filters.sourceCity)
      this.filterUrl += "&sourceCity=" + this.filters.sourceCity;
    if (this.filters.sourceCountry)
      this.filterUrl += "&sourceCountry=" + this.filters.sourceCountry;
    if (this.filters.client_id)
      this.filterUrl += "&client_id=" + this.filters.client_id;
    if (this.filters.clientEntity_id)
      this.filterUrl += "&clientEntity_id=" + this.filters.clientEntity_id;
    if (this.filters.vendor_id)
      this.filterUrl += "&vendor_id=" + this.filters.vendor_id;
    if (this.filters.vendorEntity_id)
      this.filterUrl += "&vendorEntity_id=" + this.filters.vendorEntity_id;
    if (this.filters.supplier_id)
      this.filterUrl += "&supplier_id=" + this.filters.supplier_id;
    if (this.filters.destinationCity)
      this.filterUrl += "&destinationCity=" + this.filters.destinationCity;
    if (this.filters.name) this.filterUrl += "&name=" + this.filters.name;
    if (this.filters.tariffNo)
      this.filterUrl += "&tariffNo=" + this.filters.tariffNo;
    if (this.filters.vehicleType)
      this.filterUrl += "&vehicleType=" + this.filters.vehicleType;
    common.setLoading(true);
    await this.showPage(1);
  }
}
</script>

<style scoped>
.filter-close {
  position: absolute;
  right: 5px;
  top: 5px;
}
.dialog {
  position: fixed;
  top: 100px;
  width: 60%;
  z-index: 10;
  margin-left: 15%;
}
.btn-list-item {
  padding: 0;
  float: left !important;
}
.btn-list-item .v-btn--text {
  padding: 0;
  text-transform: none;
  font-size: 14px;
  float: left;
  margin: 0;
}
</style>
